export default {"src":"/_next/static/media/amp.162c0546.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};